/* unplugin-vue-components disabled */import { render } from "./teacherCard.vue?vue&type=template&id=0ced869b&scoped=true"
import script from "./teacherCard.vue?vue&type=script&lang=js"
export * from "./teacherCard.vue?vue&type=script&lang=js"

import "./teacherCard.vue?vue&type=style&index=0&id=0ced869b&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ced869b"]])

export default __exports__